(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-story"] && !Shopify.designMode) return;
  try {
    
  class LazyVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || !('IntersectionObserver' in window)) return;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.observer = new IntersectionObserver((entries) => {
        const visible = entries.some((entry) => entry.isIntersecting);
        if (visible && !this.loaded) this.load();
        if (!this.loaded || this.reducedMotion) return;
        if (visible) {
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
        }
      }, { rootMargin: '200px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    load() {
      const { srcSmall, srcLarge } = this.video.dataset;
      const preferSmall = window.matchMedia('(max-width: 749px)').matches || navigator.connection?.saveData;
      const src = (preferSmall ? srcSmall : srcLarge) || srcSmall || srcLarge;
      if (!src) return;
      this.loaded = true;
      this.video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
      this.video.src = src;
      if (this.reducedMotion) return;
      this.video.play().catch(() => {});
    }
  }

  if (!customElements.get('lazy-video')) customElements.define('lazy-video', LazyVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  class UgcMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.group = this.querySelector('[data-group]');
      if (!this.track || !this.group) return;

      this.setup = this.setup.bind(this);
      this.resizeObserver = new ResizeObserver(() => this.setup());
      this.resizeObserver.observe(this);

      this.onBlockSelect = (event) => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.classList.add('is-paused');
      };
      this.onBlockDeselect = (event) => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.classList.remove('is-paused');
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    setup() {
      this.track.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
      const items = this.group.children.length;
      if (!items) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const groupWidth = this.group.getBoundingClientRect().width;
      if (!groupWidth) return;

      const distance = groupWidth + gap;
      const copies = Math.max(1, Math.ceil(this.clientWidth / distance) + 1);
      for (let i = 0; i < copies; i += 1) {
        const clone = this.group.cloneNode(true);
        clone.setAttribute('data-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => node.removeAttribute('data-shopify-editor-block'));
        this.track.appendChild(clone);
      }

      const speed = Number(this.dataset.speed) || 40;
      this.style.setProperty('--ugc-distance', `${distance}px`);
      this.style.setProperty('--ugc-duration', `${distance / speed}s`);
      this.classList.add('is-animated');
    }
  }

  if (!customElements.get('ugc-marquee')) customElements.define('ugc-marquee', UgcMarquee);

  } catch(e) { console.error(e); }
})();
})();
